import React from 'react';
import { Typography, Grid, Button } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import useHomePageTopicCardStyles from './HomePageTopicCard.styles';
import MarkdownLink from './MarkdownLink';
import MarkdownImage from './MarkdownImage';

export interface HomePageTopicCardProps {
  description: string;
  imageSrc: string;
  href: string;
  title: string;
  learnMoreLabel?: string;
}

export default function HomePageTopicCard({
  description,
  imageSrc,
  href,
  title,
  learnMoreLabel,
}: HomePageTopicCardProps) {
  const {
    classes: { container, image, description: descriptionStyle, title: titleStyle },
  } = useHomePageTopicCardStyles();
  const { translate } = useTranslation();

  return (
    <DynamicallyRouted.Link href={href}>
      <Grid item XSmall={12} Medium={6} XLarge={3}>
        <Grid className={container} container alignItems='center' wrap='nowrap' direction='column'>
          <MarkdownImage className={image} src={imageSrc} />
          <Typography className={titleStyle} variant='h3'>
            {title}
          </Typography>
          <Typography className={descriptionStyle} variant='body1' color='secondary'>
            {description}
          </Typography>
          <MarkdownLink href={href}>
            <Button size='large'>{learnMoreLabel ?? translate('Label.LearnMore')}</Button>
          </MarkdownLink>
        </Grid>
      </Grid>
    </DynamicallyRouted.Link>
  );
}
